import { BRAND_HAS_SAME_LOCAL_AND_DUBBED_SHOWTIMES } from 'common/configuration/constants';
import trans from 'common/tools/translations/trans';

export type ShowtimeGroupKey =
  | 'dubbed'
  | 'dubbed_st'
  | 'dubbed_sme'
  | 'local'
  | 'local_st'
  | 'local_sme'
  | 'multiple'
  | 'multiple_st'
  | 'multiple_sme'
  | 'original'
  | 'original_st'
  | 'original_sme';

const VALID_GROUP_KEY = /^(dubbed|local|multiple|original)(_st|_sme)?$/;

export const getVersionLabel = (key: ShowtimeGroupKey): string => {
  if (!VALID_GROUP_KEY.test(key)) {
    return '';
  }

  const name = trans(`showtimes.version.${key}`);

  return trans('showtimes.format', { name });
};

const SME_TAGS = [
  'Showtime.Accessibility.HearingImpaired',
  'Showtime.Accessibility.OpenCaption',
  'Showtime.Accessibility.ClosedCaption'
];

/**
 * Rebuild a single showtime's ShowtimeGroupKey from its raw diffusionVersion + tags,
 * mirroring ShowtimeHelper::buildSimpleShowtimes/buildShowtimesWithTags on the PHP side.
 */
export const getVersionGroupKey = (
  diffusionVersion: string,
  tags: string[]
): ShowtimeGroupKey => {
  const lowerVersion = diffusionVersion.toLowerCase();
  let key =
    BRAND_HAS_SAME_LOCAL_AND_DUBBED_SHOWTIMES &&
    (lowerVersion === 'local' || lowerVersion === 'dubbed')
      ? 'multiple'
      : lowerVersion;

  if (SME_TAGS.some(smeTag => tags.includes(smeTag))) {
    key += '_sme';
  } else if (tags.includes('Showtime.Accessibility.Subtitled')) {
    key += '_st';
  }

  return key as ShowtimeGroupKey;
};

export default getVersionLabel;
